<template>
<div id="c-mainContainer" class="c-mainContainer">
  <common-header></common-header>
  <mv-fv name="block0"></mv-fv>
  <mv-main-text name="block1"></mv-main-text>
  <mv-main2 name="block2"></mv-main2>
  <mv-main1 name="block3"></mv-main1>
  <mv-main1 name="block4"></mv-main1>
  <mv-main2 name="block5"></mv-main2>
  <mv-main1 name="block6"></mv-main1>
  <mv-main2 name="block7"></mv-main2>
  <mv-main1 name="block8"></mv-main1>
  <mv-main2 name="block9"></mv-main2>
  <mv-main1 name="block10"></mv-main1>
  <mv-main2 name="block11"></mv-main2>
  <mv-col3 name="block12"></mv-col3>
  <mv-main1 name="block13"></mv-main1>
  <mv-main2 name="block14"></mv-main2>
  <mv-main1 name="block15"></mv-main1>
  <mv-main1 name="block16"></mv-main1>
  <mv-main2 name="block17"></mv-main2>
  <mv-main1 name="block18"></mv-main1>
  <mv-main1 name="block19"></mv-main1>
  <mv-col2 name="block20"></mv-col2>
  <carousel name="carousel1"></carousel>
  <mv-main1 name="block21"></mv-main1>
  <mv-col2 name="block22"></mv-col2>
  <carousel name="carousel2"></carousel>
  <mv-main2 name="block23"></mv-main2>
  <mv-main1 name="block24"></mv-main1>
  <mv-col2 name="block25"></mv-col2>
  <carousel name="carousel3"></carousel>
  <mv-col3 name="block26"></mv-col3>
  <mv-main1 name="block27"></mv-main1>
  <mv-col2 name="block28"></mv-col2>
  <mv-col2 name="block29"></mv-col2>
  <mv-main1 name="block30"></mv-main1>
  <mv-main1 name="block31"></mv-main1>
  <mv-main1 name="block32"></mv-main1>
  <carousel name="carousel4"></carousel>
  <mv-main-text name="block33"></mv-main-text>
  <carousel2 name="carousel5"></carousel2>
  <common-footer></common-footer>
</div>
</template>

<script>
import {gsap, Power2, Power3} from 'gsap/all';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { ScrollSmoother } from 'gsap/ScrollSmoother';
import { ScrollToPlugin } from 'gsap/ScrollToPlugin';
gsap.registerPlugin(ScrollSmoother, ScrollTrigger, ScrollToPlugin);
// ScrollTrigger.normalizeScroll(true);
ScrollTrigger.normalizeScroll(false);
ScrollTrigger.config({ignoreMobileResize: true});

import CommonHeader from '@/_components/CommonHeader';
import CommonFooter from '@/_components/CommonFooter';
import MvFv from '@/_components/MvFv';
import MvMain1 from '@/_components/MvMain1';
import MvMain2 from '@/_components/MvMain2';
import MvMainText from '@/_components/MvMainText';
import MvCol1 from '@/_components/MvCol1';
import MvCol2 from '@/_components/MvCol2';
import MvCol3 from '@/_components/MvCol3';
import MvFunc from '@/_components/MvFunc';
import Carousel from '@/_components/Carousel';
import Carousel2 from '@/_components/Carousel2';
import CarouselKv from '@/_components/CarouselKv';

export default {
  components: {
    CommonHeader,
    CommonFooter,
    MvFv,
    MvMain1,
    MvMain2,
    MvMainText,
    MvCol1,
    MvCol2,
    MvCol3,
    MvFunc,
    Carousel,
    Carousel2,
    CarouselKv,
  },
  data() {
    return {
      ss: null,
      isInit: false,
      preWidth: 0,
    }
  },
  computed: {
  },
  mounted() {
    const container = this.$el;
    const observer = new ResizeObserver((entries) => {
      if (gPG.isDevice === 'pc' || this.preWidth !== window.innerWidth) {
        ScrollTrigger.refresh();
      }
      this.preWidth = window.innerWidth;
    });
    observer.observe(container);

    this.$nextTick(this.resize);
  },
  methods: {
    init() {
      if (this.isInit) return;
      this.isInit = true;
      this.ss = ScrollSmoother.create({
        content: '#c-mainContainer',
        ease: Power2,
        effects: false,
        smooth: 0.4,
        smoothTouch: 0.1,
        ignoreMobileResize: true,
        // normalizeScroll: true,
      });
      this.$store.commit('setScrollSmoother', this.ss);
      // ScrollTrigger.normalizeScroll(true);
      ScrollTrigger.refresh();
    },
    // destroy() {
    //   this.isInit = false;
    //   if (this.ss) {
    //     this.ss.kill();
    //     this.ss = null;
    //     this.$store.commit('setScrollSmoother', null);
    //   }
    //   ScrollTrigger.normalizeScroll(false);
    //   ScrollTrigger.refresh();
    // },
    resize() {
      // if (this.getMatchMedia(1000)) {
      //   this.destroy();
      // } else {
        this.init();
      // }
    },
    getMatchMedia(width) {
      return window.matchMedia('(max-width: ' + width +'px)').matches;
    },
  }
}
</script>